module.exports = __webpack_public_path__ + "img/44.cbc1a0e9.jpg";